
        import 'Limit.00b8fdb.css-module'
        export default {"text":"text_Limit_00b8fdb","list":"list_Limit_00b8fdb","listItem":"listItem_Limit_00b8fdb","selectedItem":"selectedItem_Limit_00b8fdb"}
    